import { render, staticRenderFns } from "./SliderBuyOnlineButton.vue?vue&type=template&id=58e5c711&"
import script from "./SliderBuyOnlineButton.vue?vue&type=script&lang=js&"
export * from "./SliderBuyOnlineButton.vue?vue&type=script&lang=js&"
import style0 from "./SliderBuyOnlineButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SliderBuyOnlineButton.vue"
export default component.exports